export default {
  computed: {
    gracePeriodDays() {
      return this.$store?.state?.organization?.grace_period_days ?? 16;
    },
    billingGraceTooltip() {
      return `Indicates whether this user is in the ${this.gracePeriodDays}-day grace period or already using a 
        paid seat on your plan.`;
    },
  },
};
